import { Redirect } from "react-router";

export function Home() {
    return <Redirect to="/sesionesActivas"></Redirect>;
}
